<template>
  <transition name="outcome-indicator">
    <span
      :key="'up'"
      class="indicator up"
      v-if="direction === 'up'"
    />
    <span
      :key="'down'"
      class="indicator down"
      v-if="direction === 'down'"
    />
  </transition>
</template>

<script>
export default {
  name: 'OutcomeIndicator',
  props: {
    direction: {
      required: false,
      type: String,
      default: 'no',
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../assets/style/variables';

.indicator {
  position: absolute;
  left: 0;
  right: 0;
  height: 70%;
  transform: translateZ(0);
  z-index: -1;

  &.up {
    top: 0;
    background: linear-gradient(to top,
      rgba($match-outcome-indicator-up-color, 0),
      rgba($match-outcome-indicator-up-color, 0.5));
  }

  &.down {
    bottom: 1px;
    background: linear-gradient(
      rgba($match-outcome-indicator-down-color, 0),
      rgba($match-outcome-indicator-down-color, 0.5));
  }
}
</style>
